import { render, staticRenderFns } from "./ProductProviderUpdate.vue?vue&type=template&id=6f7a3586"
import script from "./ProductProviderUpdate.vue?vue&type=script&lang=js"
export * from "./ProductProviderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports